export default __webpack_public_path__ + "static/media/ZangXinCamp.cf06a319.jpg";